import {
  FieldErrors,
  FieldValues,
  Path,
  UseFormSetError,
} from 'react-hook-form';

interface ResetFieldErrorProps<TSchema extends FieldValues> {
  fieldName: string;
  setError: UseFormSetError<TSchema>;
}

export const allFieldErrorsEmpty = (errors: FieldErrors) =>
  Object.values(errors).every((field) => field.message === '');

export const getMostRecentObject = (
  objects: object[],
  dateFieldName: string
) => {
  if (!objects || objects.length === 0) {
    return null;
  }

  return objects.reduce((mostRecent, current) => {
    return new Date(current[`${dateFieldName}`]) >
      new Date(mostRecent[`${dateFieldName}`])
      ? current
      : mostRecent;
  });
};

export const resetFieldError = <TSchema extends FieldValues>({
  fieldName,
  setError,
}: ResetFieldErrorProps<TSchema>) => {
  setError(fieldName as Path<TSchema>, {
    message: '',
  });
};

export const isObjectEmpty = (object: object) => {
  return Object.keys(object)?.length === 0;
};
